const SearchFilterEnum = Object.freeze({
  RESPONDENTS: 1,
  RESEARCHERS: 2,
});

export default (SearchFilterEnum);
